import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome"
import { Badge, Box, Typography } from "@mui/material"
import { tss } from "tss-react/mui"

type StyleProps = Readonly<{
    isButton: boolean
}>

const useStyles = tss.withParams<StyleProps>().create(({ theme, isButton }) => ({
    iconWrap: {
        width: "2.5rem",
        height: "2.5rem",
        borderRadius: ".5rem",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        transition: isButton ? "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms" : undefined,
        cursor: isButton ? "pointer" : undefined,
    },
    iconWrapGray: {
        color: theme.palette.tailwind.slate[500],
        background: theme.palette.tailwind.slate[100],
        "&:hover": {
            background: theme.palette.tailwind.slate[isButton ? 200 : 100],
        },
    },
    iconWrapBlue: {
        color: theme.palette.tailwind.blue[500],
        background: theme.palette.tailwind.blue[100],
        "&:hover": {
            background: theme.palette.tailwind.blue[isButton ? 200 : 100],
        },
    },
}))

export type IconBadgeProps = Readonly<{
    variant: "font-awesome" | "numeric"
    color: "blue" | "grey"
    fontAwesomeIcon?: FontAwesomeIconProps["icon"]
    value?: number
    badgeValue?: number
    className?: string
    onClick?: () => void
}>

export function IconBadge({ variant, color, fontAwesomeIcon, value, badgeValue, className, onClick }: IconBadgeProps) {
    const { classes, cx } = useStyles({ isButton: Boolean(onClick) })
    return (
        <Box className={className}>
            <Badge badgeContent={badgeValue} color="error">
                <Box
                    className={cx(classes.iconWrap, {
                        [classes.iconWrapGray]: color === "grey",
                        [classes.iconWrapBlue]: color === "blue",
                    })}
                    onClick={onClick}
                >
                        {variant === "font-awesome" && fontAwesomeIcon && (
                            <FontAwesomeIcon icon={fontAwesomeIcon} />
                        )}
                        {variant === "numeric" && value !== undefined && (
                            <Typography variant="h6">{value}</Typography>
                        )}
                </Box>
            </Badge>
        </Box>
    )
}
